import {
  SwipeableDrawer as SwipeableDrawerMui,
  SwipeableDrawerProps as SwipeableDrawerPropsMui,
} from '@mui/material';
import { styled } from '../../utils/styled';
import { themeMediaQuery } from '../../utils/themeMediaQuery';

export interface SwipeableDrawerProps extends SwipeableDrawerPropsMui {
  readonly fullHeight?: boolean;
}

export const StyledSwipeableDrawer = styled(SwipeableDrawerMui, {
  shouldForwardProp: (prop) => prop !== 'fullHeight',
})<{ fullHeight?: boolean }>`
  .MuiModal-backdrop {
    background-color: transparent;
  }

  .MuiDrawer-paper {
    border-top: 0;
    border-left: 0;
    box-shadow: ${({ theme }) => theme.boxShadows.menu};
    width: 100vw;
    border-top-right-radius: ${({ theme }) => theme.borderRadii.mobileDrawer};
    border-top-left-radius: ${({ theme }) => theme.borderRadii.mobileDrawer};

    ${({ theme, fullHeight }) => themeMediaQuery(theme, 'md')`
      width: 600px;
      height: ${fullHeight ? 'calc(100vh - 64px)' : 'calc(100vh - 144px)'};
      border-top-right-radius: 0;
      border-top-left-radius: 0;
      top: ${fullHeight ? '64px' : '143px'};
    `}
  }
`;

export function SwipeableDrawer({ children, ...rest }: SwipeableDrawerProps) {
  return <StyledSwipeableDrawer {...rest}>{children}</StyledSwipeableDrawer>;
}
